import {
    BsBuildings,
    BsHouse,
    BsShopWindow
} from "react-icons/bs";
import {
    PiBed,
    PiBuilding,
    PiBuildings,
    PiHouseLine
} from "react-icons/pi";

export const propertyOptions = (t) => ({
    "Apartment": {
        value: "Apartment",
        label: t("apartment"),
        icon: <PiBuilding size={28} />,
    },
    "Villa": {
        value: "Villa",
        label: t("villa"),
        icon: <PiHouseLine size={28} />,
    },
    "Townhouse": {
        value: "Townhouse",
        label: t("townhouse"),
        icon: <PiBuildings size={28} />,
    },
    "Commercial": {
        value: "Retail",
        label: t("commercial"),
        icon: <BsShopWindow size={28} />,
    },
});
